import { Observable } from 'rxjs';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { User } from '../_objects/user';
import { OfflineUtilsService } from '../_offline/services/offline-utils.service';
import { MeUserService } from '../_services/http-api/me-user.service';
import { TenantConfigService } from '../_services/http-api/tenant-config.service';
import { NetworkStatusService } from '../_services/network-status.service';
import { TenantConfig } from '../app.constants';
import { SpinnerService } from '../_services/spinner.service';
import { UsersStateService } from "../_services/user-state/users-state.service";
import { AuthService } from '@evc/platform';
import { RoutePage } from '../app-routes.enum';
import { FileSystemAccessService } from "../_services/file-system-access.service";
import { TranslateService } from "@ngx-translate/core";
import { CommonSnackBarService } from "../_services/common-snack-bar.service";

@Component({
    selector: 'app-license-agreement',
    templateUrl: './license-agreement.component.html',
    styleUrls: ['./license-agreement.component.scss'],
    standalone: false
})
export class LicenseAgreementComponent implements OnInit {
  title = 'License Agreement';
  serialNumberLabel = TenantConfig.DefaultConfigurationValues.LabelOfSerialNumber;
  isFirst = true;

  public isOnPremiseMode(): boolean {
    return this.networkStatusService.isOnPremise;
  }

  constructor(
    private router: Router,
    private meUserService: MeUserService,
    private networkStatusService: NetworkStatusService,
    private tenantConfigService: TenantConfigService,
    private offlineUtilsService: OfflineUtilsService,
    private authService: AuthService,
    private oscSpinnerService: SpinnerService,
    private userStateService: UsersStateService,
    private fileSystemAccessService: FileSystemAccessService,
    private translateService: TranslateService,
    private snackBarService: CommonSnackBarService,
  ) {
  }

  ngOnInit() {
    this.isFirstAccess();
    this.setConfig();
  }

  setConfig() {
    const configs = this.tenantConfigService.tenantConfig;
    if (configs) {
      const snLabelConfig = configs.find(_ => _.key === TenantConfig.LabelOfSerialNumber.KEY);
      if (snLabelConfig) {
        this.serialNumberLabel = snLabelConfig.value as string;
      }
    }
  }

  goToBrianApp() {
    this.fileSystemAccessService.executeReturnAppBatFile().subscribe(fileExists => {
      if (!fileExists) {
        this.snackBarService.open(this.translateService.instant('desktopMenu.fileNotFound'));
      }
    });
  }

  cancel() {
    if (this.networkStatusService.isBrianMode) {
      this.goToBrianApp();
    }
    else if (this.networkStatusService.isOnPremise) {
      this.offlineUtilsService.exitApp()
        .subscribe();
    } else {
      this.authService.logout();
    }
  }

  agree() {
    this.meUserService.putUserAgreeTerms().subscribe(
      user => {
        this.tenantConfigService
          .getTenantConfigs()
          .subscribe(
            res => {
              this.tenantConfigService.setTenantConfig(res);
            },
            error => console.log(error));
        this.userStateService.setIsFirstAccess(false);
        this.router.navigate([RoutePage.InspectionList]);
      },
      error => {
        console.log(error);
        this.authService.logout();
      });
  }

  isFirstAccess(): void {
    const obsMe: Observable<User> = this.meUserService.getMe();
    obsMe.subscribe(me => {
      this.isFirst = me && !me.isAgreedTerms;
      this.userStateService.setIsFirstAccess(this.isFirst);
      this.oscSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }
}
